type EntryCallback = (entry: IntersectionObserverEntry) => void

type ObserveOptions = {
    rootMargin?: string
    threshold?: number
}

type ObserverRecord = {
    observer: IntersectionObserver
    callbacks: Map<Element, EntryCallback>
}

const records = new Map<string, ObserverRecord>()

export const observeElement = (element: Element, callback: EntryCallback, options: ObserveOptions = {}): (() => void) => {
    const { rootMargin = '0px', threshold = 0 } = options

    if (typeof IntersectionObserver === 'undefined') {
        callback({ isIntersecting: true, target: element } as IntersectionObserverEntry)

        return () => {}
    }

    const key = `${rootMargin}|${threshold}`
    let record = records.get(key)

    if (!record) {
        const callbacks = new Map<Element, EntryCallback>()
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => callbacks.get(entry.target)?.(entry))
        }, { rootMargin, threshold })

        record = { observer, callbacks }
        records.set(key, record)
    }

    const current = record

    current.callbacks.set(element, callback)
    current.observer.observe(element)

    return () => {
        current.callbacks.delete(element)
        current.observer.unobserve(element)
    }
}
